import { f } from "html2pdf.js";
import { toDisplayString } from "vue";

export async function generateInvoiceHtml(form, subtotal, tax, total) {
  const res = await fetch('./invoice.html');
  if (!res.ok) {
    throw new Error(`Failed to load invoice template: ${res.status} ${res.statusText}`);
  }
  let html = await res.text();
  console.log(form,'ddd');

  // 处理表格行
  const rows = [];
  for (const item of form.items) {
    const desc = item.desc;
    const rate = Number(item.rate).toFixed(2);
    const qty = item.qty;
    const amount = (Number(item.rate) * Number(item.qty)).toFixed(2);
    rows.push('<tr><td>' + desc + '</td><td class="amount">$' + rate + '</td><td class="amount">' + qty + '</td><td class="amount">$' + amount + '</td></tr>');
  }
  html = html.replace(/<tbody>[\s\S]*?<\/tbody>/, '<tbody>' + rows.join('') + '</tbody>');

  // 生成税号显示文本
  let taxIdDisplay = '';
  let taxIdLabel = '';
  if (form.taxType === 'HST') {
    taxIdLabel = 'HST #:';
    taxIdDisplay = form.taxId ? form.taxId + ' RT 0001' : '';
  } else if (form.taxType === 'SIN') {
    taxIdLabel = 'SIN #:';
    taxIdDisplay = form.taxId ? form.taxId : '';
  } else {
    taxIdLabel = '';
    taxIdDisplay = 'Non-resident of Canada';
  }

  console.log(taxIdDisplay,'taxIdDisplay');
  
  // 直接替换税号显示
  html = html.replace(
    '<tr>\n              <td class="payable-item" style="width: 80px;text-align: right;"></td>\n              <td id="tax-id-display"></td>\n            </tr>',
    '<tr>\n              <td class="payable-item" style="width: 80px;text-align: right;">' + taxIdLabel + '</td>\n              <td>' + taxIdDisplay + '</td>\n            </tr>'
  );

  // 使用 HTML 结构匹配替换变量，不依赖默认值
  
  // 替换发票号
  html = html.replace(
    /(<div class="invoice-title">INVOICE # )([^<]+)(<\/div>)/,
    '$1' + form.invoiceNo + '$3'
  );

  // 替换 Issue Date
  html = html.replace(
    /(Issue Date:<\/td>\s*<td[^>]*>)([^<]+)(<\/td>)/,
    '$1' + form.issueDate + '$3'
  );

  // 替换 Due Date
  html = html.replace(
    /(Due Date:<\/td>\s*<td[^>]*>)([^<]+)(<\/td>)/,
    '$1' + form.dueDate + '$3'
  );

  // 替换 Film Code
  html = html.replace(
    /(Film Code:<\/td>\s*<td[^>]*>)([^<]+)(<\/td>)/,
    '$1' + form.filmCode + '$3'
  );

  // 替换 Role
  html = html.replace(
    /(Role:<\/td>\s*<td[^>]*>)([^<]+)(<\/td>)/,
    '$1' + form.role + '$3'
  );

  // 替换 Name (在 PAYABLE TO 部分)
  html = html.replace(
    /(Name:<\/td>\s*<td>)([^<]+)(<\/td>)/,
    '$1' + form.name + '$3'
  );

  // 替换 Address1
  html = html.replace(
    /(Address:<\/td>\s*<td>)([^<]+)(<\/td>)/,
    '$1' + form.address1 + '$3'
  );

  // 处理 address2 行的显示/隐藏
  if (!form.address2) {
    html = html.replace(/<tr id="address2-row">[\s\S]*?<\/tr>/, '');
  } else {
    html = html.replace(
      /(<tr id="address2-row">\s*<td><\/td>\s*<td>)([^<]+)(<\/td>\s*<\/tr>)/,
      '$1' + form.address2 + '$3'
    );
  }

  // 替换城市、省份、邮编（在 address2 行之后）
  const cityProvincePostal = (form.city || '') + ', ' + (form.province || '') + ' ' + (form.postalCode || '');
  html = html.replace(
    /(<tr>\s*<td><\/td>\s*<td>)([^<]+)(<\/td>\s*<\/tr>\s*<tr>\s*<td[^>]*>Email:)/,
    '$1' + cityProvincePostal + '$3'
  );

  // 替换 Email
  html = html.replace(
    /(Email:<\/td>\s*<td>)([^<]+)(<\/td>)/,
    '$1' + form.email + '$3'
  );

  // 替换 Institution No. (匹配完整的 tr 行，确保精确匹配)
  html = html.replace(
    /(<tr[^>]*>\s*<td[^>]*>Institution No.:<\/td>\s*<td>)([^<]+)(<\/td>\s*<td[^>]*>EMT Email:)/,
    '$1' + form.institutionNo + '$3'
  );

  // 替换 Transit No. (匹配完整的 tr 行，包含后续的空 td，确保精确匹配)
  html = html.replace(
    /(<tr[^>]*>\s*<td[^>]*>Transit No.:<\/td>\s*<td>)([^<]+)(<\/td>\s*<td><\/td>\s*<td><\/td>\s*<\/tr>)/,
    '$1' + form.transitNo + '$3'
  );

  // 替换 Account No. (匹配完整的 tr 行，包含后续的空 td，确保精确匹配)
  html = html.replace(
    /(<tr[^>]*>\s*<td[^>]*>Account No.:<\/td>\s*<td>)([^<]+)(<\/td>\s*<td><\/td>\s*<td><\/td>\s*<\/tr>)/,
    '$1' + form.accountNo + '$3'
  );

  // 替换 EMT Email
  html = html.replace(
    /(EMT Email:<\/td>\s*<td>)([^<]+)(<\/td>)/,
    '$1' + form.emtEmail + '$3'
  );
  console.log(taxIdDisplay,'taxIdDisplay');
  // 替换金额
  html = html
    .replace(/Subtotal: \$[\d.,]+/g, 'Subtotal: $' + subtotal.toFixed(2))
    .replace(/Tax \(GST\/HST\): \$[\d.,]+/g, 'Tax (GST/HST): $' + tax.toFixed(2))
    .replace(/Amount Due: \$[\d.,]+/g, 'Amount Due: $' + total.toFixed(2));
    console.log(taxIdDisplay,'taxIdDisplay');
  return html;
} 